import { render, staticRenderFns } from "./ShowManifest.vue?vue&type=template&id=3a95b72e&scoped=true&"
import script from "./ShowManifest.vue?vue&type=script&lang=js&"
export * from "./ShowManifest.vue?vue&type=script&lang=js&"
import style0 from "./ShowManifest.vue?vue&type=style&index=0&id=3a95b72e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a95b72e",
  null
  
)

export default component.exports